module.exports = __webpack_public_path__ + "static/img/200114.dad2ab2b.png";